import { render, staticRenderFns } from "./Initials.vue?vue&type=template&id=1b60053c&"
import script from "./Initials.vue?vue&type=script&lang=js&"
export * from "./Initials.vue?vue&type=script&lang=js&"
import style0 from "./Initials.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports